import React from 'react'
import { AppBar, Box } from '@fedsim/components'
import { PALETTE } from "@fedsim/constants";

import Topbar from './topbar'
import Main from './main'
import Footer from './footer'

import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { red, green, blue } from '@mui/material/colors';

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    backgroundColor: red[500],
  },
  [theme.breakpoints.up('md')]: {
    backgroundColor: blue[500],
  },
  [theme.breakpoints.up('lg')]: {
    backgroundColor: green[500],
  },
}));

export function MediaQuery() {
  return (
    <Root>
      <Typography>down(md): red</Typography>
      <Typography>up(md): blue</Typography>
      <Typography>up(lg): green</Typography>
    </Root>
  );
}

function Layout({ color = true, children = null }) {
  return (
    <Box sx={{
      background: color ? PALETTE.CONTENTAREA : 'linear-gradient(to right, #6a82fb, #fc5c7d)',
      color: PALETTE.CONTENTAREATEXT,
    }}>
      <AppBar
        sx={{
          top: 0,
          left: 0,
          position: 'absolute',
          // backgroundColor: PALETTE.HEADER,
          color: PALETTE.HEADERTEXT,
          zIndex: theme => theme.zIndex.drawer - 1,
          borderBottom: `3px solid ${PALETTE.DIVIDER}`
        }}
      >
        <Topbar />
      </AppBar>
      <Main>
        {children}
        <br />
      </Main>
      <Footer />
    </Box>
  )
}

export default Layout
